export enum SlotState {
  OPEN = 'OPEN',
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  BOOKED = 'BOOKED',
}

export type TimeSlot = {
  date: string;
  slots: SlotState[];
}

export enum ViewAs {
  ELITE_TUTOR = 'ELITE_TUTOR',
  ELITE_SEEKER = 'ELITE_SEEKER',
  ELITE_TUTOR_BOOKING = 'ELITE_TUTOR_BOOKING',
}
